// extracted by mini-css-extract-plugin
export default {"infoIconWrapper":"PreventiveRecallList_infoIconWrapper__2GHSn"};